var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDashboard({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4686 16.7621C12.017 17.2014 12.7967 17.2011 13.3448 16.7615L20.0167 11.4104L20.2457 11.2277C20.9974 10.628 20.9987 9.4858 20.2482 8.88451L13.3449 3.35311C12.7967 2.91388 12.0172 2.91388 11.469 3.35311L4.5612 8.88809C3.8122 9.48823 3.81172 10.6277 4.5602 11.2284L4.78687 11.4104L11.4686 16.7621Z",
    fill: "#4A4B68"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.3337 19.4712C12.7856 19.9103 12.0062 19.9104 11.458 19.4714L5.52523 14.7195C5.1138 14.3899 4.51196 14.4625 4.19071 14.8805C3.87421 15.2922 3.95106 15.8825 4.36243 16.1995L11.4892 21.6912C12.0287 22.1069 12.7805 22.107 13.3201 21.6914L20.4435 16.2044C20.8584 15.8848 20.9357 15.2894 20.6162 14.8745C20.2923 14.4539 19.6862 14.3811 19.2719 14.7131L13.3337 19.4712Z",
    fill: "#4A4B68"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/Dashboard.910096cb6b21075d5e9dccbbe0581e76.svg";
export { ForwardRef as ReactComponent };